<template>
  <div
    class="ntv-center-label"
    ref="wrapper"
    @click="onClick"
  >
    <!-- Wrap in span since ntv-text doesn't have mouseover/leave events -->
    <span
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
    >
      <ntv-text
        class="ntv-center-label__text cursor-pointer"
        ref="text"
        v-bind="$attrs"
        :text="text ? text + '' : ''"
        has-ellipsis
        v-tooltip="tooltip"
        :style="{
          maxWidth
        }"
      />
    </span>
  </div>
</template>

<script>
import NtvText from '@nui/Text'
import NtvTooltip from '@nui/Tooltip'

export default {
  name: 'NtvCenterLabel',

  directives: {
    tooltip: NtvTooltip.VTooltip
  },

  components: {
    NtvText
  },

  props: {
    text: {
      type: [String, Number, Boolean],
      default: ''
    }
  },

  data () {
    return {
      maxWidth: '',
      tooltip: null
    }
  },

  watch: {
    text () {
      this.handleTooltip()
    }
  },

  methods: {
    handleTooltip () {
      const wrapper = this.$refs.wrapper
      const text = this.$refs.text.$el

      this.maxWidth = wrapper.offsetWidth + 'px'

      if (text.scrollWidth > wrapper.clientWidth) {
        this.tooltip = {
          content: this.text,
          boundariesElement: '.ntv-text'
        }
      } else {
        this.tooltip = null
      }
    },
    onClick (e) {
      this.$emit('click', e)
    },
    onMouseEnter (e) {
      this.$emit('mouseenter', e)
    },
    onMouseLeave (e) {
      this.$emit('mouseleave', e)
    }
  },

  mounted () {
    this.handleTooltip()
  }
}
</script>

<style>
.ntv-center-label__text:hover {
  text-shadow: 0.5px 0 0 currentColor
}
</style>
